import dayjs from 'dayjs';

export type DateFieldValue = Date | string | null | undefined;

// Reads a stored timestamp as the calendar day it represents in UTC, which is
// how the backend renders these dates into the exported PDFs. Formatting in the
// browser's local zone would shift a UTC-midnight value to the previous day.
export const toDateInputValue = (value: DateFieldValue): string => {
  if (!value) return '';

  if (value instanceof Date) {
    return Number.isNaN(value.getTime())
      ? ''
      : value.toISOString().slice(0, 10);
  }

  const trimmed = value.trim();
  const isoDate = trimmed.match(/^(\d{4}-\d{2}-\d{2})(?:$|T)/)?.[1];
  if (isoDate && dayjs(isoDate, 'YYYY-MM-DD', true).isValid()) {
    return isoDate;
  }

  const parsed = dayjs(trimmed);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
};

// Stores a picked date as noon UTC so it lands on the same calendar day
// regardless of the viewer's timezone offset.
export const dateInputToIso = (value: DateFieldValue): string | null => {
  const dateInput = toDateInputValue(value);
  if (!dateInput) return null;

  const parsed = dayjs(`${dateInput}T12:00:00.000Z`);
  return parsed.isValid() ? parsed.toISOString() : null;
};
